import { asHintId, type Hint } from '@/shared/stores';

import { CARE_STATE_FIRST_OPEN_REQUEST_ANCHOR } from './anchors';

/** First in the patient-workspace sequence. */
export const openRequestHint: Hint = {
  id: asHintId('patient-workspace:open-request'),
  version: 1,
  priority: 100,
  anchor: CARE_STATE_FIRST_OPEN_REQUEST_ANCHOR,
  copy: {
    title: 'An open request to handle',
    body: 'Each open request represents something Cortex thinks needs attention for this patient. Open the Actions tab to see what Cortex proposes.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
